import React from "react";

/**
 * Compact KPI row shared by the Requests and Stock Items tabs.
 *
 * `tiles` is `[{ label, value, tone }]` where tone keys into the palette below.
 * Kept deliberately plain — the surrounding fee and trip screens use the same
 * bordered-card look rather than antd Statistic.
 */
const TONES = {
  neutral: { bg: "#f8fafc", border: "#e2e8f0", text: "#475569" },
  pending: { bg: "#fffbeb", border: "#fde68a", text: "#b45309" },
  success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d" },
  info: { bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8" },
  danger: { bg: "#fef2f2", border: "#fecaca", text: "#b91c1c" },
};

const StockSummaryStrip = ({ tiles = [], loading }) => {
  if (loading || !tiles.length) return null;

  return (
    <div
      className="pb-6"
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${tiles.length}, minmax(0, 1fr))`,
        gap: 12,
      }}
    >
      {tiles.map(({ label, value, tone = "neutral" }) => {
        const palette = TONES[tone] || TONES.neutral;
        return (
          <div
            key={label}
            style={{
              background: palette.bg,
              border: `1px solid ${palette.border}`,
              borderRadius: 12,
              padding: "12px 16px",
            }}
          >
            <div
              style={{
                fontSize: 22,
                fontWeight: 600,
                lineHeight: 1.2,
                color: palette.text,
              }}
            >
              {value}
            </div>
            <div style={{ fontSize: 12, color: "#64748b" }}>{label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default StockSummaryStrip;
